// extracted by mini-css-extract-plugin
export default {"business_outline":"Outline_business_outline__FUXG9"};